// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__3VAeU","noInteraction":"EventWrapper_noInteraction__2hrK_"};